// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"262eae57","322":"feb80c0a"}[chunkId] + ".chunk.js";
};